import { useState, useEffect, useRef } from "react";
import "../Styles/Products.css";
import { MdOutlineArrowOutward } from "react-icons/md";
import { IoClose } from "react-icons/io5";
import ProductDetails from "../Components/ProductDetails.js";
import { useTranslation } from "react-i18next";
import { FaWhatsapp } from "react-icons/fa";
import { useParams } from "react-router-dom";

const Products = () => {
  const [viewAll, setViewAll] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState("");
  const [productmodalOpen, setProductModalOpen] = useState(false);
  const [selectedProductDetail, setSelectedProductDetail] = useState(null);
  const [filteredProducts, setFilteredProducts] = useState([]);

  const { t } = useTranslation();
  const { category } = useParams();
  const scrollContainerRef = useRef(null);
  const scrollSpeed = 1; // Adjust speed

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    let animationFrame;
    let isPaused = false;
    const scrollSpeed = 1.5; // Adjust speed as needed

    const smoothScroll = () => {
      if (!isPaused) {
        container.scrollLeft += scrollSpeed;

        // Reset scroll position when it reaches halfway to create loop effect
        if (container.scrollLeft >= container.scrollWidth / 2) {
          container.scrollLeft = 0;
        }
      }
      animationFrame = requestAnimationFrame(smoothScroll);
    };

    animationFrame = requestAnimationFrame(smoothScroll);

    const handleMouseEnter = () => (isPaused = true);
    const handleMouseLeave = () => (isPaused = false);

    container.addEventListener("mouseenter", handleMouseEnter);
    container.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      cancelAnimationFrame(animationFrame);
      container.removeEventListener("mouseenter", handleMouseEnter);
      container.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, []);


  // Fetching all products (Example Data)
  const allProducts = t("productsData.reasons", { returnObjects: true });

  useEffect(() => {
    if (category && category !== "all") {
      // Filter products based on category
      console.log(category, 'categoryFromPARAMS')
      const filtered = allProducts.filter(
        (product) => product.category.toLowerCase() === category.toLowerCase()
      );
      setFilteredProducts(filtered);
    } else {
      // Show all products if category is "all" or undefined
      setFilteredProducts(allProducts);
    }
  }, [category]);

  // Open Product Details Modal
  const openProductModal = (product) => {
    setSelectedProductDetail(product);
    setProductModalOpen(true);
  };

  // Close Product Details Modal
  const closeProductModal = () => {
    setSelectedProductDetail(null);
    setProductModalOpen(false);
  };

  // Toggle View All Button
  const toggleViewAll = () => {
    setViewAll(!viewAll);
  };

  // Open Enquiry Modal
  const openEnquiryModal = (product, event) => {
    event.stopPropagation(); // Prevents triggering product modal
    setSelectedProduct(product);
    setShowModal(true);
  };

  // Handle Phone Number Input
  const handlePhoneNumberChange = (e) => {
    const value = e.target.value;
    setPhoneNumber(value);

    const phonePattern = /^[6-9]\d{9}$/; // Indian phone validation
    if (!phonePattern.test(value)) {
      setError("Please enter a valid 10-digit mobile number.");
    } else {
      setError("");
    }
  };

  const sendEnquiry = () => {
    const phonePattern = /^[6-9]\d{9}$/;
  
    if (!phonePattern.test(phoneNumber)) {
      setError("Please enter a valid 10-digit mobile number.");
      return;
    }
  
    const salesManagerNumber = "919826273330";
    
    // Properly encode the message using %0A for new lines
    const formattedMessage = encodeURIComponent(
      `Hello, I am interested in the following product:%0A
      🛍 Product: ${selectedProduct.name}%0A
      📂 Category: ${selectedProduct.category}%0A
      📞 Contact Number: ${phoneNumber}%0A
      Please provide me with more details.`
    );
  
    const whatsappUrl = `https://api.whatsapp.com/send?phone=${salesManagerNumber}&text=${formattedMessage}`;
    window.open(whatsappUrl, "_blank");
  
    // Reset form and close modal
    setPhoneNumber("");
    setShowModal(false);
  };
  

  return (
    <div className="products-section">
      {/* <div className="leaf-decoration"></div> */}

      <div className="products-header">
        <h2>{t("productsData.title")}</h2>
        {/* <div className="navigation-controls">
          <button
            className="nav-button left"
            onClick={() =>
              scrollContainerRef.current.scrollBy({ left: -300, behavior: "smooth" })
            }
          >
            ❮
          </button>
          <button
            className="nav-button right"
            onClick={() =>
              scrollContainerRef.current.scrollBy({ left: 300, behavior: "smooth" })
            }
          >
            ❯
          </button>
        </div> */}
        <div className="view-btn">
          <button className="view-all" onClick={toggleViewAll}>
            {viewAll ? "Collapse" : "View All"}
          </button>
        </div>
      </div>

      <div
        className={`products-container ${viewAll ? "view-all-mode" : ""}`}
        ref={scrollContainerRef}
      >
        {/* {filteredProducts.map((product, index) => (
          <div className="product-card" key={index} onClick={() => openProductModal(product)}>
            <div className="product-image">
              <img src={product.image || "/placeholder.svg"} alt={product.name} />
            </div>
            <div className="product-info">
              <h3 className="product-name">{product.name}</h3>
              <span className="product-category">{product.category}</span>
            </div>
            <button
              className="product-action"
              onClick={(e) => {
                e.stopPropagation();
                openEnquiryModal(product);
              }}
            >
              <MdOutlineArrowOutward size={28} />
              <span>{t("productsData.enquiryBtn")}</span>
            </button>
          </div>
        ))}
      </div> */}

        {filteredProducts.length > 0 ? (
          filteredProducts.map((product, index) => (
            <div
              className="product-card"
              key={index}
              onClick={() => openProductModal(product)}
            >
              <div className="product-image">
                <img
                  src={product.image || "/placeholder.svg"}
                  alt={product.name}
                />
              </div>
              <div className="product-info">
                <h3 className="product-name">{product.name}</h3>
                <span className="product-category1">
                  {product.scientificName}
                </span>
              </div>
              <button
                className="product-action"
                onClick={(e) => openEnquiryModal(product, e)}
              >
                <MdOutlineArrowOutward size={28} />
                <span>{t("productsData.enquiryBtn")}</span>
              </button>
            </div>
          ))
        ) : (
          <p>No products found in this category</p>
        )}
      </div>

      {/* Enquiry Modal */}
      {showModal && (
        <div className="modal" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="cross-btn" onClick={() => setShowModal(false)}>
              <IoClose size={28} color="white" />
            </button>
            <h3>{t("productsData.contactHeading")}</h3>
            <p>{t("productsData.contactMsg")}</p>
            <input
              type="tel"
              placeholder="Enter 10-digit mobile number"
              value={phoneNumber}
              onChange={handlePhoneNumberChange}
              maxLength={10}
            />
            {error && <p style={{ color: "red", fontSize: "14px" }}>{error}</p>}

            {/* Button Container for styling */}
            <div className="button-container">
              <button className="send-btn" onClick={sendEnquiry}>
                {t("productsData.btntext")}
              </button>
              <button className="whatsapp-btn" onClick={sendEnquiry}>
                <FaWhatsapp size={24} color="white" />
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Product Details Modal */}
      {productmodalOpen && selectedProductDetail && (
        <ProductDetails
          product={selectedProductDetail}
          open={productmodalOpen}
          onClose={closeProductModal}
        />
      )}
    </div>
  );
};

export default Products;






